/* ============================================================
 * Tarjetas de producto (móvil) — v4: complementos del track de
 * swipe + nudge "desliza" (clon Scuffers, más lento).
 *
 * El swipe NO lleva JS: scroll nativo con snap (pcard-slider.css
 * sobre [data-pcard-slider]). Aquí solo:
 * - initSlider: arranca el track en la foto activa (featured) y
 *   re-sincroniza los dots del theme desde el scroll real.
 * - Nudge: cuando el PRIMER track de una sección llega a media
 *   pantalla, se elige la tarjeta EN ESE MOMENTO — la primera
 *   VISUAL del DOM ya reordenado por región (fix del bug "sale en
 *   la 2ª": region-products-reorder.js mueve las tarjetas tras
 *   cargar; antes se elegía la primera del HTML del servidor). Si
 *   hay config de región y el grid aún no está reordenado
 *   (data-region-applied), se espera hasta ~1.6s antes de armar.
 * - Cancelación por el scroll REAL del track (solo horizontal por
 *   definición): el scroll vertical de página ya no mata el nudge.
 * - MutationObserver: secciones AJAX (recos PDP) y re-renders.
 * ============================================================ */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');

  function initSlider(track) {
    if (track.__pcardInit) return;
    track.__pcardInit = true;

    var block = track.closest('product-block');

    // Si la featured no es la primera foto del DOM, arrancar el track en ella
    if (MOBILE.matches) {
      var slides = track.children;
      for (var i = 1; i < slides.length; i++) {
        if (slides[i].classList.contains('product-block__image--active')) {
          track.scrollLeft = slides[i].offsetLeft;
          break;
        }
      }
    }

    function update() {
      var slide = track.firstElementChild;
      var w = slide ? slide.offsetWidth : 0;
      if (!w || !block) return;
      var index = Math.round(track.scrollLeft / w);
      block.querySelectorAll('.product-block__image-dot').forEach(function (el, iter) {
        el.classList.toggle('product-block__image-dot--active', iter === index);
      });
    }
    track.addEventListener('scroll', update, { passive: true });

    watchSection(track);
  }

  function isVisible(el) {
    if (!el.offsetParent && getComputedStyle(el).position !== 'fixed') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  // Primera tarjeta VISUAL de la sección en este instante (post-reorder)
  function pickTarget(sec) {
    var tracks = sec.querySelectorAll('[data-pcard-slider]');
    for (var i = 0; i < tracks.length; i++) {
      if (isVisible(tracks[i])) return tracks[i];
    }
    return null;
  }

  // Si Region Manager va a reordenar este grid, esperar a que lo haga
  function regionPending(sec) {
    if (!document.getElementById('region-products-config')) return false;
    var grid = sec.querySelector('.product-grid');
    return !!(grid && grid.querySelectorAll('product-block').length > 1 && !grid.dataset.regionApplied);
  }

  function arm(sec, retries) {
    if (!MOBILE.matches) return;
    if (regionPending(sec) && retries > 0) {
      setTimeout(function () { arm(sec, retries - 1); }, 200);
      return;
    }
    var track = pickTarget(sec);
    if (!track) return;
    // La 2ª foto puede seguir display:none (lazy del theme): activarla para
    // que el empujón enseñe foto real y no el fondo del track.
    var next = track.querySelector('.product-block__image--show-on-hover');
    if (next) next.classList.remove('product-block__image--inactivated');
    track.classList.add('pcard-swipe-hint');
    track.addEventListener('scroll', function off() {
      track.classList.remove('pcard-swipe-hint');
      track.removeEventListener('scroll', off);
    }, { passive: true });
  }

  function watchSection(track) {
    var sec = track.closest('.shopify-section') || document.body;
    if (sec.__pcardHint) return;
    sec.__pcardHint = true;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); arm(sec, 8); return; }
        }
      }, { threshold: 0.5 });
      // Observar TODOS los tracks de la sección: dispara el primero que llegue
      // a media pantalla (la tarjeta concreta se elige en arm(), post-reorder).
      sec.querySelectorAll('[data-pcard-slider]').forEach(function (t) { io.observe(t); });
    } else {
      arm(sec, 8);
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-pcard-slider]').forEach(initSlider);
  }

  function ready() { scan(); }
  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-pcard-slider]')) initSlider(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
